import { ThunkAction, ThunkDispatch } from 'redux-thunk';

import { BeneficiaryService } from '@/services/BeneficiaryService';

import {
  AllBeneficiariesActionTypes,
  IAllBeneficiariesState,
  TAllBeneficiariesAction,
} from '@/features/beneficiaries/store/types/all-beneficiaries.types';
import {
  IFilterBeneficiary,
  IBeneficiary,
  TMetaBeneficiary,
} from '@/features/beneficiaries/store/models/beneficiary.model';

import { TAppError } from '@/store/types/base.state';

export const getAllBeneficiaries = (
  filter?: IFilterBeneficiary,
): ThunkAction<Promise<void>, IAllBeneficiariesState, {}, TAllBeneficiariesAction> => {
  const request = (): TAllBeneficiariesAction => ({
    type: AllBeneficiariesActionTypes.SEARCH_ALL_BENEFICIARIES,
  });
  const fail = (error: TAppError): TAllBeneficiariesAction => ({
    type: AllBeneficiariesActionTypes.SEARCH_ALL_BENEFICIARIES_FAIL,
    error,
    documentation: 'https://docs.treezor.com/guide/cards/introduction.html#key-attributes',
  });
  const success = (beneficiaries: IBeneficiary[], meta: TMetaBeneficiary): TAllBeneficiariesAction => ({
    type: AllBeneficiariesActionTypes.SEARCH_ALL_BENEFICIARIES_SUCCESS,
    shouldSkipToaster: true,
    beneficiaries,
    meta,
  });

  return async (dispatch: ThunkDispatch<{}, {}, TAllBeneficiariesAction>): Promise<void> => {
    dispatch(request());
    try {
      const { beneficiaries, meta } = await BeneficiaryService.getBeneficiaries(filter);

      dispatch(success(beneficiaries, meta));
    } catch (error) {
      dispatch(fail(error));
    }
  };
};
